import { PendingSquadInvite } from "../../types";

export const getSquadsPendingInvitesModel = (response: PendingSquadInvite): PendingSquadInvite => response;
